import React, { useState, useEffect } from "react";
import {
  Box, Grid, TextField, Button, FormControlLabel, Switch,
  Divider, CircularProgress, Paper,
} from "@mui/material";
import Swal from "sweetalert2";
import { GetAllStationsAdmin } from "api/stations";
import { StoreRoute, PatchRoute } from "api/routes";
import NavigatorEditor from "./NavigatorEditor";

const defaultForm = {
  id: "", name: "", description: "", validflag: true, isFanshine: false, agentId: "", navigator: [],
};

const RouteForm = ({ editData, onSaved, onCancel }) => {
  const [form, setForm] = useState(defaultForm);
  const [stations, setStations] = useState([]);
  const [loading, setLoading] = useState(false);
  const isEdit = !!editData;

  useEffect(() => {
    GetAllStationsAdmin().then((res) => { if (res.success) setStations(res.data); });
  }, []);

  useEffect(() => {
    if (editData) setForm({ ...defaultForm, ...editData });
    else setForm(defaultForm);
  }, [editData]);

  const handleChange = (field) => (e) => {
    const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleNavigatorChange = (newNavigator) => setForm((prev) => ({ ...prev, navigator: newNavigator }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.navigator.length === 0) {
      Swal.fire({ title: "No stations", icon: "warning", text: "Please add at least one station to the route." });
      return;
    }
    setLoading(true);
    const res = isEdit ? await PatchRoute(form) : await StoreRoute(form);
    setLoading(false);
    if (res.success) {
      Swal.fire({ title: isEdit ? "Updated!" : "Created!", icon: "success", timer: 1500, showConfirmButton: false });
      if (onSaved) onSaved();
      if (!isEdit) setForm(defaultForm);
    } else {
      Swal.fire({ title: "Error", icon: "error", text: res.message });
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ pt: 1 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={3}>
          <TextField fullWidth label="Route ID *" value={form.id} onChange={handleChange("id")} disabled={isEdit} required size="small" />
        </Grid>
        <Grid item xs={12} sm={5}>
          <TextField fullWidth label="Route Name *" value={form.name} onChange={handleChange("name")} required size="small" />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField fullWidth label="Agent ID (optional)" value={form.agentId} onChange={handleChange("agentId")} size="small" />
        </Grid>
        <Grid item xs={12}>
          <TextField fullWidth label="Description" value={form.description} onChange={handleChange("description")} size="small" multiline rows={2} />
        </Grid>
        <Grid item xs={12}>
          <Box display="flex" gap={2}>
            <FormControlLabel control={<Switch checked={!!form.validflag} onChange={handleChange("validflag")} color="secondary" />} label="Active" />
            <FormControlLabel control={<Switch checked={!!form.isFanshine} onChange={handleChange("isFanshine")} color="secondary" />} label="Fanshine Route" />
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Divider sx={{ my: 1 }} />
          <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
            <NavigatorEditor stations={stations} navigator={form.navigator} onChange={handleNavigatorChange} />
          </Paper>
        </Grid>

        <Grid item xs={12}>
          <Box display="flex" gap={1} justifyContent="flex-end" mt={1}>
            {onCancel && (
              <Button variant="outlined" color="secondary" onClick={onCancel} disabled={loading}>Cancel</Button>
            )}
            <Button type="submit" variant="contained" color="secondary" disabled={loading} startIcon={loading && <CircularProgress size={16} />}>
              {isEdit ? "Save Changes" : "Create Route"}
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default RouteForm;
